import { useMemo } from "react";
import { useTranslatorOptions } from "../useTranslatorOptions";
import { createConfigurationTranslateFunctions } from "./createConfigurationTranslateFunctions";
export function useCreateConfigurationTranslateFunctions() {
    const options = useTranslatorOptions();
    return useMemo(() => createConfigurationTranslateFunctions(options), [options]);
}
//# sourceMappingURL=useCreateConfigurationTranslateFunctions.js.map